import * as React from "react"

function MasterCardIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 82 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <rect
                x={0.938}
                y={0.642}
                width={80.425}
                height={49.319}
                rx={5.5}
                fill="#fff"
            />
            <path
                d="M31.874 38.46c6.546 0 11.853-5.891 11.853-13.16 0-7.267-5.307-13.158-11.853-13.158-6.546 0-11.853 5.891-11.853 13.159 0 7.268 5.306 13.16 11.853 13.16z"
                fill="#EA001B"
            />
            <path
                d="M48.806 38.46c6.547 0 11.853-5.891 11.853-13.16 0-7.267-5.306-13.158-11.853-13.158-6.546 0-11.853 5.891-11.853 13.159 0 7.268 5.307 13.16 11.853 13.16z"
                fill="#FFA200"
                fillOpacity={0.8}
            />
            <rect
                x={0.938}
                y={0.642}
                width={80.425}
                height={49.319}
                rx={5.5}
                stroke="#CECECE"
            />
        </svg>
    )
}

export default MasterCardIcon
